{
  "common.close": "Zapri",
  "common.athleteFallback": "športnik {id}",
  "splash.title": "{app} — animirana vizualizacija dejavnosti",
  "splash.tagline": "Tvoji podatki iz Strave v&nbsp;gibanju",
  "splash.demo": "Predstavitev",
  "tab.query.title": "Zemljevid: {name}",
  "tab.query.heading": "Poizvedba dejavnosti:",
  "tab.query.optDays": "zadnji dnevi",
  "tab.query.optActivities": "zadnje dejavnosti",
  "tab.query.optIds": "ID-ji dejavnosti",
  "tab.query.optDates": "Časovno obdobje",
  "tab.query.idsPlaceholder": "sem vnesi ID-je dejavnosti",
  "tab.query.after": "Od:",
  "tab.query.before": "Do:",
  "tab.query.autozoom": "Po uvozu samodejno povečaj <i class=\"hf hf-bullseye\"></i> na rezultate",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> Naloži",
  "tab.query.createAccount": "Ustvari račun in/ali se prijavi.",
  "tab.query.sports": "Športi:",
  "tab.query.allSports": "Vsi športi",
  "tab.query.sportsExcept": "Vsi razen",
  "tab.query.sportsNone": "Noben",
  "tab.query.loadingSports": "Nalaganje športov…",
  "tab.query.sportsFailed": "Športov na tem zemljevidu ni bilo mogoče naložiti",
  "tab.query.noSports": "Še ni dejavnosti",
  "tab.activities.title": "Prikazane dejavnosti",
  "tab.activities.clearSelection": "Počisti izbor",
  "tab.activities.renderSelected": "Prikaži izbrane",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> Povečaj na izbor",
  "tab.controls.title": "Nastavitve sloja",
  "tab.controls.timescale": "Časovna skala <i>&tau;</i>",
  "tab.controls.timescaleHint": "hitrost predvajanja",
  "tab.controls.period": "Perioda <i>T</i>",
  "tab.controls.periodHint": "dejavnost ~ model",
  "tab.controls.dotSize": "Velikost pik",
  "tab.controls.pathWidth": "Širina poti",
  "tab.controls.pathWidthHint": "nič skrije poti",
  "tab.controls.colors": "Barve",
  "tab.controls.colorsHint": "zavrti paleto",
  "tab.controls.shadows": "Sence",
  "tab.profile.loginTitle": "Prijava",
  "tab.profile.anonNote": "Prijavi se s Stravo, da vidiš svoje dejavnosti in upravljaš svoj račun Heatflask.",
  "tab.profile.loginLink": "Prijava s Stravo",
  "tab.profile.editOnStrava": "Uredi svoj profil na Stravi",
  "tab.profile.indexNote": "Povzetke tvojih dejavnosti indeksiramo za hiter dostop.",
  "tab.profile.viewIndex": "Prikaži indeks",
  "tab.profile.sharedMaps": "Deljeni zemljevidi",
  "tab.profile.sharedMapsNote": "Izklopljeno: svoje dejavnosti na Heatflasku vidiš samo ti. Vklopljeno: vsak, ki ima povezavo do tvojega zemljevida, vidi dejavnosti, ki so na Stravi javne. Zasebne v vsakem primeru ostanejo samo tvoje. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">Kako deluje zasebnost</a>",
  "tab.profile.logout": "Odjava",
  "tab.profile.deleteAccount": "Izbriši račun",
  "tab.profile.deleteConfirm": "Želiš izbrisati svoj račun Heatflask?\n\nS tem se odstranijo tvoje indeksirane dejavnosti, Heatflask pa izgubi dostop do tvojih podatkov na Stravi. Tega ni mogoče razveljaviti.",
  "tab.profile.languageHeading": "Jezik",
  "tab.profile.languageAuto": "Samodejno",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">Pomagaj nam popraviti prevode ali dodati nove!</a>",
  "tab.profile.unitsHeading": "Enote",
  "tab.profile.unitsAuto": "Samodejno",
  "tab.profile.unitsMetric": "Metrične (km, m)",
  "tab.profile.unitsImperial": "Imperialne (mi, ft)",
  "tab.profile.textSizeHeading": "Velikost besedila",
  "tab.profile.textSmaller": "Manjše",
  "tab.profile.textReset": "Običajno",
  "tab.profile.textLarger": "Večje",
  "tab.profile.mapDefaultsHeading": "Privzete nastavitve zemljevida",
  "tab.profile.mapDefaultsNote": "Ta podlaga, teren in nastavitve sloja se uporabijo vsakič, ko odpreš zemljevid, katerega povezava ne določa svojih. Povezave, ki jih deliš, še vedno prikažejo natanko to, kar vidiš ti.",
  "tab.profile.mapDefaultsSave": "Shrani kot privzeto",
  "tab.profile.mapDefaultsForget": "Pozabi",
  "tab.info.title": "Informacije",
  "tab.info.controlsHeading": "Upravljanje",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + vleka",
  "tab.info.shiftDragDesc": "Izberi dejavnosti v okvirju. Na zaslonu na dotik najprej tapni <i class=\"hf-object-group\"></i>, nato povleci z enim prstom. Zadnja izbrana dejavnost prikaže svoje podrobnosti, seznam dejavnosti pa se pomakne do nje.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + vleka",
  "tab.info.ctrlDragDesc": "Zavrti in nagni zemljevid v 3D ali uporabi dva prsta",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "Odpri ali zapri stransko vrstico",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "Prejšnji ali naslednji zavihek",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "Zapri stransko vrstico",
  "tab.info.liveUrlHeading": "Živi URL",
  "tab.info.liveUrlDesc": "Pogled zemljevida in nastavitve animacije so shranjeni v URL-ju strani, zato vsak, s komer ga deliš, vidi enak pogled.",
  "tab.info.videoHeading": "Izvoz videa",
  "tab.info.videoDesc": "Gumb <i class=\"hf-video-camera\"></i> posname animacijo kot MP4: tapni ga, prilagodi okvir čez del zemljevida, ki ga želiš, in tapni znova za snemanje. Posname se en cel krog animacije, zato se video brezšivno ponavlja; krog, daljši od {max} sekund (najdaljši video, ki ga Strava sprejme), se odreže pri {max}.",
  "tab.info.contributeHeading": "Prispevaj",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> Podpri na GitHubu",
  "tab.info.contactsHeading": "Stik",
  "map.basemapAndTerrain": "Podlaga in teren",
  "map.pauseAnimation": "Začasno ustavi animacijo",
  "map.resumeAnimation": "Nadaljuj animacijo",
  "capture.record": "Posnemi video (krog {period} s)",
  "capture.recordTruncated": "Posnemi video (en krog traja {period} s; posnetih bo le prvih {max} s)",
  "capture.recordArea": "Posnemi območje znotraj okvirja",
  "capture.stop": "Ustavi snemanje",
  "capture.selectionTooSmall": "izbor je premajhen",
  "capture.saved": "shranjeno: {name} ({size})",
  "capture.cancelled": "snemanje preklicano",
  "capture.failed": "snemanje ni uspelo: {error}",
  "capture.loadingEncoder": "nalaganje kodirnika…",
  "capture.waitingForMap": "čakanje, da se zemljevid naloži…",
  "capture.encoding": "kodiranje… {percent} %",
  "capture.finalizing": "zaključevanje…",
  "share.title": "Deli povezavo do tega zemljevida",
  "share.copied": "povezava kopirana",
  "share.copiedUnshared": "povezava kopirana – vendar tvoj zemljevid ni deljen, zato ga nihče drug ne more odpreti. Za spremembo vklopi »Deljeni zemljevidi«.",
  "share.unshared": "Tvoj zemljevid ni deljen, zato te povezave nihče drug ne more odpreti. Za spremembo vklopi »Deljeni zemljevidi«.",
  "share.copyThis": "Kopiraj to povezavo:",
  "update.available": "Na voljo je nova različica Heatflaska.",
  "update.reload": "Znova naloži",
  "import.title": "Uvažanje",
  "import.stop": "Ustavi",
  "import.stopping": "ustavljanje…",
  "import.contacting": "povezovanje s Stravo…",
  "import.countOf": "Dejavnosti: {received} od {total}",
  "import.count": "Dejavnosti: {received}",
  "import.waitStrava": "Zaradi Stravine omejitve prenosov začasno ustavljeno do {time}. Pusti stran odprto; ponovno nalaganje tega ne bo pospešilo.",
  "import.waitRationed": "Današnji hitri prenosi so porabljeni. Ostalo se nadaljuje ob {time}, počasneje. Pusti stran odprto.",
  "import.dailyLimit": "Stravina dnevna omejitev prenosov je porabljena. Poskusi znova po {time}.",
  "import.dailyRationed": "Tvoj današnji delež prenosov s Strave je porabljen. Poskusi znova po {time}.",
  "import.noActivitiesYet": "Tvoj račun na Stravi še nima dejavnosti. Posnemi ali naloži eno na Stravo in prikazala se bo tukaj.",
  "table.noActivities": "ni dejavnosti",
  "table.untitled": "(brez naslova)",
  "activities.pageTitle": "{app} — Indeks dejavnosti",
  "activities.heading": "Indeks dejavnosti",
  "activities.fetching": "Pridobivanje dejavnosti...",
  "activities.rateLimit": "Dosežena omejitev zahtev Strave; nadaljevanje ob {time}",
  "activities.noData": "Žal ni podatkov &#128577;",
  "activities.colServerCache": "Sled je predpomnjena na strežniku (Mongo)",
  "activities.colBrowserCache": "Sled je predpomnjena v tem brskalniku",
  "activities.cachedServer": "Sled za {id} je predpomnjena na strežniku",
  "activities.notCachedServer": "Sled za {id} ni predpomnjena na strežniku",
  "activities.cachedBrowser": "Sled za {id} je predpomnjena v tem brskalniku",
  "activities.notCachedBrowser": "Sled za {id} ni predpomnjena v tem brskalniku",
  "sport.AlpineSki": "Alpsko smučanje",
  "sport.BackcountrySki": "Turno smučanje",
  "sport.Badminton": "Badminton",
  "sport.Basketball": "Košarka",
  "sport.Canoeing": "Kanu",
  "sport.Cricket": "Kriket",
  "sport.Crossfit": "Crossfit",
  "sport.Dance": "Ples",
  "sport.EBikeRide": "Vožnja z e-kolesom",
  "sport.Elliptical": "Eliptični trenažer",
  "sport.EMountainBikeRide": "Vožnja z e-gorskim kolesom",
  "sport.Golf": "Golf",
  "sport.GravelRide": "Gravel vožnja",
  "sport.Handcycle": "Ročno kolo",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "Pohod",
  "sport.IceSkate": "Drsanje",
  "sport.InlineSkate": "Rolanje",
  "sport.Kayaking": "Kajak",
  "sport.Kitesurf": "Kajtanje",
  "sport.MountainBikeRide": "Gorsko kolesarjenje",
  "sport.NordicSki": "Tek na smučeh",
  "sport.Padel": "Padel",
  "sport.PhysicalTherapy": "Fizioterapija",
  "sport.Pickleball": "Pickleball",
  "sport.Pilates": "Pilates",
  "sport.Racquetball": "Racquetball",
  "sport.Ride": "Kolesarjenje",
  "sport.RockClimbing": "Plezanje",
  "sport.RollerSki": "Rolkanje na smučeh",
  "sport.Rowing": "Veslanje",
  "sport.Run": "Tek",
  "sport.Sail": "Jadranje",
  "sport.Skateboard": "Rolkanje",
  "sport.Snowboard": "Deskanje na snegu",
  "sport.Snowshoe": "Hoja s krpljami",
  "sport.Soccer": "Nogomet",
  "sport.Squash": "Squash",
  "sport.StairStepper": "Stopnice (trenažer)",
  "sport.StandUpPaddling": "Veslanje stoje (SUP)",
  "sport.Surfing": "Deskanje",
  "sport.Swim": "Plavanje",
  "sport.TableTennis": "Namizni tenis",
  "sport.Tennis": "Tenis",
  "sport.TrailRun": "Trail tek",
  "sport.Velomobile": "Velomobil",
  "sport.VirtualRide": "Virtualno kolesarjenje",
  "sport.VirtualRow": "Virtualno veslanje",
  "sport.VirtualRun": "Virtualni tek",
  "sport.Volleyball": "Odbojka",
  "sport.Walk": "Hoja",
  "sport.WeightTraining": "Trening z utežmi",
  "sport.Wheelchair": "Invalidski voziček",
  "sport.Windsurf": "Jadranje na deski",
  "sport.Workout": "Vadba",
  "sport.Yoga": "Joga"
}
